import classNames from 'classnames';
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { AccordionHeader } from '../accordion-header/index';
import { CodeSnippet } from '../code-snippet/index';
import { getStyles } from './see-example-styles';

const SeeExampleUnstyled = (props) => {
  const {
    classes,
    className,
    i18n,
    exampleTemplate,
    message,
    model,
  } = props;
  const [showExample, setShowExample] = useState(false);

  const handleAccordionHeaderChange = useCallback((_ev, expanded) => {
    setShowExample(expanded);
  }, []);

  return (
    <div className={classNames(className, classes.seeExampleContainer, 'see-example')}>
      <AccordionHeader
        className="example-header"
        expanded={showExample}
        onChange={handleAccordionHeaderChange}
        i18n={i18n}
      >
        {i18n.getString(_TL_('Not sure how to do it? See an example'))}
      </AccordionHeader>
      {showExample && (
        <div className="example">
          <div className="example-message">{message}</div>
          <CodeSnippet
            aria-label={props['aria-label']}
            className="example-code-snippet"
            codeTemplate={exampleTemplate}
            model={{
              highlighted: text => <mark>{text}</mark>,
              ...model,
            }}
          />
        </div>
      )}
    </div>
  );
};

SeeExampleUnstyled.propTypes = {
  'aria-label': PropTypes.string,
  classes: PropTypes.shape({ seeExampleContainer: PropTypes.string }).isRequired,
  className: PropTypes.string,
  i18n: PropTypes.shape({}).isRequired,
  exampleTemplate: PropTypes.string,
  message: PropTypes.string.isRequired,
  model: PropTypes.shape({}),
};

SeeExampleUnstyled.defaultProps = {
  'aria-label': undefined,
  className: undefined,
  exampleTemplate: undefined,
  model: {},
};

export const SeeExample = withDefaultStyles(SeeExampleUnstyled, getStyles);
